const ACTION_PATTERN =
  /^\s*ctx\.(showPanel|hidePanel|togglePanel|playSound|playPanelVideo|pausePanelVideo)\(\s*(['"])((?:\\.|(?!\2).)*)\2\s*\)\s*$/;

function splitActions(code) {
  const actions = [];
  let start = 0;
  let quote = '';
  let escaped = false;

  for (let index = 0; index < code.length; index += 1) {
    const char = code[index];
    if (escaped) {
      escaped = false;
      continue;
    }
    if (char === '\\' && quote) {
      escaped = true;
      continue;
    }
    if (quote) {
      if (char === quote) quote = '';
      continue;
    }
    if (char === "'" || char === '"') {
      quote = char;
      continue;
    }
    if (char === ';') {
      const action = code.slice(start, index).trim();
      if (action) actions.push(action);
      start = index + 1;
    }
  }

  if (quote || escaped) return null;
  const finalAction = code.slice(start).trim();
  if (finalAction) actions.push(finalAction);
  return actions.length > 0 && actions.length <= 8 ? actions : null;
}

function decodeArgument(value) {
  let decoded = '';
  for (let index = 0; index < value.length; index += 1) {
    const char = value[index];
    if (char !== '\\') {
      decoded += char;
      continue;
    }

    index += 1;
    if (index >= value.length) return null;
    const escaped = value[index];
    switch (escaped) {
      case '\\':
      case "'":
      case '"':
        decoded += escaped;
        break;
      case 'n':
        decoded += '\n';
        break;
      case 'r':
        decoded += '\r';
        break;
      case 't':
        decoded += '\t';
        break;
      default:
        return null;
    }
  }
  return decoded;
}

/**
 * Executes the intentionally tiny action language accepted by world files.
 * Keeping this declarative avoids eval/new Function and makes authored content
 * compatible with a strict Content-Security-Policy.
 */
export function runInteractionAction(code, context) {
  const actionStrings = splitActions(code);
  if (!actionStrings) return false;

  const parsed = [];
  for (const action of actionStrings) {
    const match = ACTION_PATTERN.exec(action);
    if (!match) return false;
    const argument = decodeArgument(match[3]);
    if (argument === null) return false;
    parsed.push({ method: match[1], argument });
  }

  for (const { method, argument } of parsed) {
    context[method](argument);
  }
  return true;
}
